import { Firebase } from './firebase'

let hasResolved = false
let resolveAuthReady
let isInitialised = false

const authReady = new Promise((resolve) => {
  resolveAuthReady = resolve
})

const resolveOnce = () => {
  if (!hasResolved) {
    hasResolved = true
    resolveAuthReady()
  }
}

export const initAuthReady = (store) => {
  if (isInitialised) {
    return authReady
  }
  isInitialised = true

  store.commit('user/setLoading', false)

  Firebase.auth().getRedirectResult().then(function () {
    // no-op
  }, function (error) {
    console.log(error)
    if (error.code === 'auth/user-disabled') {
      store.commit('user/setError', 'Your account is pending approval by an Admin.')
    }
    const email = error.email
    if (error.code === 'auth/account-exists-with-different-credential') {
      Firebase.auth().fetchSignInMethodsForEmail(email).then(function (providers) {
        console.log(providers)
        store.commit('user/setError', 'Your email is associated with a different login method - either ECB IT or Gmail, or email/password.')
      })
    }
  })

  Firebase.auth().onAuthStateChanged((user) => {
    if (!user) {
      resolveOnce()
      return
    }

  store.commit('user/setLoading', true)
  store.dispatch('user/patch', { id: user.uid, last_log_in: new Date() })

  const load1 = new Promise((resolve, reject) => {
    store.dispatch('user/openDBChannel').then(resolve).catch(reject)
  })
  const load2 = new Promise((resolve, reject) => {
    store.dispatch('config/fetchAndAdd').then(resolve).catch(reject)
  })
  const load5 = new Promise((resolve, reject) => {
    store.dispatch('brands/fetchAndAdd').then(resolve).catch(reject)
  })

  Promise.all([load1, load2, load5]).then(() => {
    store.commit('user/setLoading', false)
    resolveOnce()
  })
    .catch(error => {
      console.log(error)
      store.commit('user/setError', error)
      store.commit('user/setLoading', false)
      resolveOnce()
    })
  })

  return authReady
}

export default authReady
